import React, { useEffect } from "react";
import Grid2 from "@mui/material/Unstable_Grid2";
import { useOutletContext, Link, useLocation } from "react-router-dom";
import BackButton from "./BackButton";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";

import { useTheme } from "@mui/material/styles";

function NoMatch() {
    const { state } = useLocation();
    const theme = useTheme();

    // The search input values are passed back if the form input if the button is used.
    const { previousPath, barcode } = state;
    const { modelValue, manufacturerValue } = useOutletContext();

    useEffect(() => {
        document.title = "HD+ Checker | Nein";

        // Google analytics event. Global `gtag` function should be defined.
        if (window.gtag) {
            let type = "scan";
            switch (state.previousPath) {
                case "/input":
                    type = "manual";
                    break;
                case "/scan":
                default:
                    type = "scan";
                    break;
            }

            window.gtag("event", "checker_result", {
                manufacturer: manufacturerValue,
                model: modelValue,
                state: "fail",
                type,
            });
        }
    }, [state.previousPath, modelValue, manufacturerValue]);

    return (
        <div className="main-container">
            <Grid2 container>
                <Grid2 xs={1} xsOffset={1} style={{ marginTop: "1rem" }}>
                    <BackButton />
                </Grid2>

                <Grid2 xs={10} xsOffset={1} style={{ marginTop: 0 }}>
                    <Stack spacing={2}>
                        <Grid2
                            xs={12}
                            sx={{
                                justifyContent: "center",
                                alignItems: "center",
                                display: "flex",
                            }}
                        >
                            <Box
                                component="img"
                                alt="Blue cross"
                                src="blue-cross.svg"
                            />
                        </Grid2>
                        <Grid2 xs={12}>
                            {barcode && (
                                <p
                                    style={{
                                        ...theme.classNames.resultModelText,
                                    }}
                                >
                                    EAN: {barcode}
                                </p>
                            )}

                            {modelValue && (
                                <p
                                    style={{
                                        ...theme.classNames.resultModelText,
                                    }}
                                >
                                    {modelValue}
                                </p>
                            )}

                            <p
                                style={{
                                    ...theme.classNames.resultMainText,
                                    color: theme.palette.warning.main,
                                }}
                            >
                                {
                                    "Dieses Modell hat die HD+ TV-App leider nicht integriert oder ist uns noch nicht bekannt."
                                }
                            </p>
                        </Grid2>
                        {previousPath === "/input" && (
                            <Grid2
                                xs={12}
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                style={{ marginTop: 0 }}
                            >
                                <Link
                                    to={"/input"}
                                    state={{ previousPath: "/no-match" }}
                                    style={{ width: "100%" }}
                                >
                                    <Button
                                        style={{
                                            backgroundColor: "#202020",
                                            width: "100%",
                                        }}
                                        variant="contained"
                                    >
                                        Erneut Eingeben
                                    </Button>
                                </Link>
                            </Grid2>
                        )}
                        {(previousPath === "/scan" || !state.previousPath) && (
                            <Grid2
                                xs={12}
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                style={{ marginTop: 0 }}
                            >
                                <Link
                                    to={"/scan"}
                                    state={{ previousPath: "/no-match" }}
                                    style={{ width: "100%" }}
                                >
                                    <Button
                                        style={{
                                            backgroundColor: "#202020",
                                            width: "100%",
                                        }}
                                        variant="contained"
                                    >
                                        Erneut Scannen
                                    </Button>
                                </Link>
                            </Grid2>
                        )}
                    </Stack>
                </Grid2>
            </Grid2>
        </div>
    );
}

export default NoMatch;
